import { useEffect } from 'react';

import Hero from 'react-scale/components/pages/open-datasets/oxford/hero';
import Overview from 'react-scale/components/pages/open-datasets/oxford/overview';
import DataCollection from 'react-scale/components/pages/open-datasets/oxford/data-collection';
import DataAnnotation from 'react-scale/components/pages/open-datasets/oxford/data-annotation';
import GetStarted from 'react-scale/components/pages/open-datasets/oxford/get-started';
import { Footer } from 'react-scale/components';

const Oxford = () => {
  useEffect(() => {
    document.documentElement.style.scrollBehavior = 'smooth';

    return () => {
      document.documentElement.style.scrollBehavior = 'unset';
    };
  }, []);

  return (
    <div className="relative text-white bg-black">
      <Hero />
      <Overview />
      <DataCollection />
      <DataAnnotation />
      <GetStarted />
      <Footer border />
    </div>
  );
};

export default Oxford;
